import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import searchFetcher from "@/common/fetchSearchServices";
import { SEARCH_LAB_ENABLED } from "@globalConfig";
import { searchLab__similar } from "@/apis/searchLab/searchLab";
export var api__getSimilarPosts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(postId) {
    var _res$data;
    var size,
      req,
      _yield$searchLab__sim,
      products,
      params,
      res,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          size = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
          req = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
          if (!SEARCH_LAB_ENABLED) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return searchLab__similar(req, {
            post_id: postId
          }, size !== null && size !== void 0 ? size : 20);
        case 1:
          _yield$searchLab__sim = _context.v;
          products = _yield$searchLab__sim.products;
          return _context.a(2, products || null);
        case 2:
          params = {
            post_id: postId,
            size: size !== null ? size : undefined // If size is provided, include it in the params
          };
          _context.n = 3;
          return searchFetcher(req).get("/similar-items/si_1?", {
            params: params
          });
        case 3:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function api__getSimilarPosts(_x) {
    return _ref.apply(this, arguments);
  };
}();